//@flow
import * as React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { TwoChildrenTemplate, Localities, Areas } from 'components'
import { fetchRegion } from 'store/operations'
import { clearResources } from 'store/actions'

function RegionsPage({
  match: {
    params: { region },
  },
  dispatch,
}) {
  React.useEffect(() => {
    if (region) {
      dispatch(fetchRegion(region))
    }
    return () => dispatch(clearResources())
  }, [dispatch, region])
  return (
    <TwoChildrenTemplate>
      <Localities />
      <Areas whiteHeader />
    </TwoChildrenTemplate>
  )
}

export default connect()(withRouter(RegionsPage))
